import $ from 'jquery';
import store from './store';
import { createApp } from 'vue';
import sdnNotificationApp from './components/sdn_notification_app';
import abTestingGroupAApp from './components/abtesting_group_a_app';

const SDN_NOTIFICATION = '#sdn_notification_app';

export function initSdnNotificationApp() {
  if ($(SDN_NOTIFICATION).length) {
    const sdnData = $(SDN_NOTIFICATION).data();
    createApp(sdnNotificationApp, { sdnData: sdnData }).use(store).mount(SDN_NOTIFICATION);
  }
}

const ABTEST_GROUP_A = '#abtesting_group_a_app';

export function initAbTestingGroupAApp() {
  if ($(ABTEST_GROUP_A).length) {
    const sdnData = $(ABTEST_GROUP_A).data();
    createApp(abTestingGroupAApp, { sdnData: sdnData }).use(store).mount(ABTEST_GROUP_A);
  }
}
